import { createSlice } from "@reduxjs/toolkit";
import { initialNavigationState } from "./navigation.type";
import { startAppListening } from "core/src/store/store.listener";
import { afterNavigateListener } from "../listeners/afterNavigate.listener";
import { storeLatestLocation } from "../useCases/store-latest-location/storeLatestLocation.use-case";
import { navigate } from "../useCases/navigate/navigate.use-case";
import { afterUpdateLocation } from "../listeners/afterUpdateLocation.listener";
import { updateLocation } from "../useCases/update-location/updateLocation.use-case";

const NAVIGATION_KEY = "navigation";

const navigationSlice = createSlice({
	name: NAVIGATION_KEY,
	initialState: initialNavigationState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(updateLocation.fulfilled, (state, action) => {
				state.location = {
					...initialNavigationState.location,
					pathname: action.payload.pathname,
				};
			})
			.addCase(navigate.fulfilled, (state, action) => {
				state.location = {
					...state.location,
					pathname: action.payload.pathname,
				};
			})
			.addCase(storeLatestLocation.fulfilled, (state, action) => {
				if (action.payload) {
					state.location = {
						...state.location,
						...action.payload,
					};
				}
			});
	},
});

export const navigation = navigationSlice.reducer;

export const navigationActions = navigationSlice.actions;

startAppListening(afterNavigateListener);
startAppListening(afterUpdateLocation);
